import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type OrganizationWorkflowOptionsSaveFailedAction = {
	type: 'ORGANIZATION_WORKFLOW_OPTIONS_SAVE_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): OrganizationWorkflowOptionsSaveFailedAction => ({
	type: 'ORGANIZATION_WORKFLOW_OPTIONS_SAVE_FAILED',
	payload,
});
